import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE, ONTOLOGICAL_MODEL_UPDATED, REQUEST_TASK_COMPLETED, REQUEST_TASK_RUNNING, SOCIAL_COMMENT_TASK_COMPLETED, SOCIAL_LIKE_TASK_COMPLETED, SOURCE_TASK_COMPLETED, SOURCE_TASK_RUNNING, SUMMARY_REPORT_OBJECT_ADDED, TASK_LOG_ITEM_ADDED } from "./constants";
export default {
    REQUEST_TASK_RUNNING: {
        signalR: REQUEST_TASK_RUNNING,
        redux: createActionType(FULL_NAMESPACE, REQUEST_TASK_RUNNING)
    },
    REQUEST_TASK_COMPLETED: {
        signalR: REQUEST_TASK_COMPLETED,
        redux: createActionType(FULL_NAMESPACE, REQUEST_TASK_COMPLETED)
    },
    SOURCE_TASK_RUNNING: {
        signalR: SOURCE_TASK_RUNNING,
        redux: createActionType(FULL_NAMESPACE, SOURCE_TASK_RUNNING)
    },
    SOURCE_TASK_COMPLETED: {
        signalR: SOURCE_TASK_COMPLETED,
        redux: createActionType(FULL_NAMESPACE, SOURCE_TASK_COMPLETED)
    },
    SUMMARY_REPORT_OBJECT_ADDED: {
        signalR: SUMMARY_REPORT_OBJECT_ADDED,
        redux: createActionType(FULL_NAMESPACE, SUMMARY_REPORT_OBJECT_ADDED)
    },
    TASK_LOG_ITEM_ADDED: {
        signalR: TASK_LOG_ITEM_ADDED,
        redux: createActionType(FULL_NAMESPACE, TASK_LOG_ITEM_ADDED)
    },
    SOCIAL_COMMENT_TASK_COMPLETED: {
        signalR: SOCIAL_COMMENT_TASK_COMPLETED,
        redux: createActionType(FULL_NAMESPACE, SOCIAL_COMMENT_TASK_COMPLETED)
    },
    SOCIAL_LIKE_TASK_COMPLETED: {
        signalR: SOCIAL_LIKE_TASK_COMPLETED,
        redux: createActionType(FULL_NAMESPACE, SOCIAL_LIKE_TASK_COMPLETED)
    },
    ONTOLOGICAL_MODEL_UPDATED: {
        signalR: ONTOLOGICAL_MODEL_UPDATED,
        redux: createActionType(FULL_NAMESPACE, ONTOLOGICAL_MODEL_UPDATED)
    }
};
